<template>
    <div class="calculadora" onselectstart='return false'>
        <div class="resultado">{{resultado}}</div>
        <div @click="borrar()" class='btn oscuro'>C</div>
        <div @click="signo()" class='btn oscuro'>+/-</div>
        <div @click="porcentaje()" class='btn oscuro'>%</div>
        <div @click="dividir()" class='btn operador'>/</div>
        <div @click="agregar(7)" class='btn'>7</div>
        <div @click="agregar(8)" class='btn'>8</div>
        <div @click="agregar(9)" class='btn'>9</div>
        <div @click="multiplicar()" class='btn operador'>*</div>
        <div @click="agregar(4)" class='btn'>4</div>
        <div @click="agregar(5)" class='btn'>5</div>
        <div @click="agregar(6)" class='btn'>6</div>
        <div @click="restar()" class='btn operador'>-</div>
        <div @click="agregar(1)" class='btn'>1</div>
        <div @click="agregar(2)" class='btn'>2</div>
        <div @click="agregar(3)" class='btn'>3</div>
        <div @click="sumar()" class='btn operador'>+</div>
        <div @click='agregar(0)' class='btn cero btn-abajo'>0</div>
        <div @click='puntoDecimal()' class='btn btn-abajo'>.</div>
        <div @click='igual()' @keyup.enter='igual()' class='btn operador btn-abajo'>=</div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      resultado: 0,
      operadorClick: false,
      operador: null,
      anterior: null,
      puntito: false
    }
  },
  methods: {
    borrar () {
      this.resultado = 0
    },
    signo () {
      this.resultado =
        this.resultado < 0
          ? (this.resultado = this.resultado - this.resultado * 2)
          : (this.resultado = this.resultado - this.resultado * 2)
    },
    porcentaje () {
      this.resultado = this.resultado / 100
    },
    agregar (numero) {
      console.log('Valor de operadorClick: ' + this.operadorClick)
      console.log('Valor de puntito: ' + this.puntito)
      if (this.operadorClick && !this.puntito) {
        this.resultado = numero
        this.operadorClick = false
      } else {
        if (this.operadorClick && this.puntito) {
          this.resultado = '' + this.resultado + numero
          this.puntito = false
          this.operadorClick = false
        } else {
          this.resultado =
          this.resultado === 0
            ? (this.resultado = numero)
            : '' + this.resultado + numero
        }
      }
    },
    puntoDecimal () {
      if (this.operadorClick) {
        console.log('Rosita')
        this.resultado = '0.'
        this.puntito = true
      }
      if (/\d+\.+/g.test(this.resultado)) {
        console.log('Decimal')
      } else {
        this.resultado = this.resultado + '.'
      }
    },
    dividir () {
      this.operador = (a, b) => a / b
      this.anterior = this.resultado
      this.operadorClick = true
    },
    multiplicar () {
      this.operador = (a, b) => a * b
      this.anterior = this.resultado
      this.operadorClick = true
    },
    restar () {
      this.operador = (a, b) => a - b
      this.anterior = this.resultado
      this.operadorClick = true
    },
    sumar () {
      this.operador = (a, b) => a + b
      this.anterior = this.resultado
      this.operadorClick = true
    },
    igual () {
      console.log('Entramos a igual')
      this.resultado = this.operador(Number(this.anterior), Number(this.resultado))
      this.anterior = null
      this.operadorClick = true
    }
  }
}
</script>

<style>
.calculadora {
  margin: 0 auto;
  width: 80vw;
  font-size: 2rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: minmax(10vh, auto);
  /* border: 5px solid #111; */
  box-shadow: -3px 3px 15px rgba(17,17,17,0.4);
  line-height: 10vh;
}
.resultado {
  grid-column: 1 / 5;
  background: black;
  color: white;
  /* border: 1px solid #111; */
  border-top: 0;
  font-size: 2.5rem;
  cursor: default;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 1rem;
  text-align: right;
}
.cero {
  grid-column: 1 / 3;
}
.btn {
  background: #D4D4D2;
  /* border: 1px solid #111; */
  cursor: pointer;
}
.btn:active {
  outline:none;
  /* border: 1px solid #000000BF;  */
  background: #2F2F31;
  color: white;
  box-shadow: inset 0px 0px 5px #00000080; 
  -moz-box-shadow: inset 0px 0px 5px #00000080;
  -webkit-box-shadow: inset 0px 0px 5px #00000080;
}
.btn-abajo {
  border-bottom: 0;
}
.operador {
  background: #F49E3F;
  color: white;
}
.oscuro {
  background: #424345;
  color: white;
}

@media only screen and (min-width: 0px){
  .calculadora {
    width: 100%;
    grid-auto-rows: minmax(14vh, auto);
    line-height: 14vh;
  }
}

@media only screen and (min-width: 768px) {
  .calculadora {
    width: 100%;
    grid-auto-rows: minmax(7.5vh, auto);
    line-height: 7.5vh;
  }
}
@media only screen and (min-width: 1024px) {
  .calculadora {
    width: 100%;
  }
}
@media only screen and (min-width: 1280px) {
  .calculadora {
    width: 20vw;
  }
}
@media only screen and (min-width: 1600px) {
  .calculadora {
    width: 15vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Calculadora.vue